import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { FragmentNames, RespiratoryMonitoringViewerAliases } from '../../../codegen';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { HttpService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../constants/routes';
import { Endpoint } from '../../../constants/endpoints';
import { Value } from '@philips-internal/oswald-ui-core';
import { ActionAPI, FieldAPI, FormAPI, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { HealthProfessionalUser } from 'src/app/authentication';
import { VitalSignRootService } from '../../vital-sign/vital-sign-respiratory-monitoring/vital-sign-root-service';

@Controller({ fragment: FragmentNames.RESPIRATORY_MONITORING_VIEWER })
class RespiratoryMonitoringViewerController extends BaseController {

  internalNavigation!: boolean;

  @Inject(RespiratoryMonitoringViewerAliases.FORM_RESPIRATORY_MONITORING_VIEWER)
  private formApi!: FormAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_RESPIRACAO)
  private dsRespiracaoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_PADRAO)
  private dsPadraoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_DISP)
  private dsDispApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_MOD_VENT)
  private dsModVentApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_ESQUIPAMENTO)
  private dsEquipamentoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_SATURACAO)
  private qtSaturacaoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FIO)
  private qtFioApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FREQ_VENT)
  private qtFreqVentApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FREQ_PROG)
  private qtFreqProgApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_AMPLITUDE)
  private qtAmplitudeApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_PIP)
  private qtPipApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_PEEP)
  private qtPeepApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_PVA)
  private qtPvaApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FLUXO_INSP)
  private qtFluxoInspApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_TEMPO_INSP)
  private qtTempoInspApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_DS_MUSCULO)
  private dsMusculoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_OXIDO_NITRICO)
  private qtOxidoNitricoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FLUXO_OXIDO)
  private qtFluxoOxidoApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.FIELD_QT_FLUXO_OXIGENIO)
  private qtFluxoOxigenioApi!: FieldAPI;

  @Inject(RespiratoryMonitoringViewerAliases.ACTION_INACTIVATE_RESPIRATORY_MONITORING)
  private actionInactivateApi!: ActionAPI;

  @Inject(RespiratoryMonitoringViewerAliases.ACTION_NEW_RESPIRATORY_MONITORING)
  private actionNewApi!: ActionAPI;

  validateVisibleFields(record: Record<string, Value>): void {
    const keys = Object.keys(record);
    keys.forEach(key => {
      switch (key) {
        case 'dsRespiracao':
          this.dsRespiracaoApi.setVisible(true);
          break;
        case 'dsPadrao':
          this.dsPadraoApi.setVisible(true);
          break;
        case 'dsDisp':
          this.dsDispApi.setVisible(true);
          break;
        case 'dsModVent':
          this.dsModVentApi.setVisible(true);
          break;
        case 'dsEsquipamento':
          this.dsEquipamentoApi.setVisible(true);
          break;
        case 'qtSaturacao':
          this.qtSaturacaoApi.setVisible(true);
          break;
        case 'qtFio':
          this.qtFioApi.setVisible(true);
          break;
        case 'qtFreqVent':
          this.qtFreqVentApi.setVisible(true);
          break;
        case 'qtFreqProg':
          this.qtFreqProgApi.setVisible(true);
          break;
        case 'qtAmplitude':
          this.qtAmplitudeApi.setVisible(true);
          break;
        case 'qtPip':
          this.qtPipApi.setVisible(true);
          break;
        case 'qtPeep':
          this.qtPeepApi.setVisible(true);
          break;
        case 'qtPva':
          this.qtPvaApi.setVisible(true);
          break;
        case 'qtFluxoInsp':
          this.qtFluxoInspApi.setVisible(true);
          break;
        case 'qtTempoInsp':
          this.qtTempoInspApi.setVisible(true);
          break;
        case 'dsMusculo':
          this.dsMusculoApi.setVisible(true);
          break;
        case 'qtOxidoNitrico':
          this.qtOxidoNitricoApi.setVisible(true);
          break;
        case 'qtFluxoOxido':
          this.qtFluxoOxidoApi.setVisible(true);
          break;
        case 'qtFluxoOxigenio':
          this.qtFluxoOxigenioApi.setVisible(true);
          break;

        default:
          break;
      }
    })
  }

  @OnMount({ target: RespiratoryMonitoringViewerAliases.RESPIRATORY_MONITORING_VIEWER_LAYOUT })
  handleLayoutMount(): void {
    InformationBarUtils.collapsedBar = true;
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();

    this.context.set({encounterId, patientId});
  }

  @OnMount({ target: RespiratoryMonitoringViewerAliases.FORM_RESPIRATORY_MONITORING_VIEWER })
  handleFormMount(): void {
    const { encounterId, patientId, sequenceNumber } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && VitalSignRootService.isAllowEdit;

    HttpService.get(Endpoint.RESPIRATORY_MONITORING_DETAIL, {
      encounterId,
      patientId,
      sequenceNumber
    }
    ).then(response => {
      const record = response.body as Record<string, Value>;
      const user = foundationContext.getUser() as HealthProfessionalUser;
      const showInactivate = record.professionalCode === user.physicalPersonId && Boolean(record.showInactivate) && allowInfo;

      this.validateVisibleFields(record);
      this.actionInactivateApi.setEnabled(showInactivate);
      this.formApi.setData(record);
    }).finally(() => {
      this.actionNewApi.setEnabled(allowInfo);
    });
  }

  @OnClick({ target: RespiratoryMonitoringViewerAliases.ACTION_NEW_RESPIRATORY_MONITORING })
  handleClickNew(): void {
    applicationContext.redirect(ApplicationRoute.RESPIRATORY_MONITORING_CREATE);
  }

  @OnClick({ target: RespiratoryMonitoringViewerAliases.ACTION_INACTIVATE_RESPIRATORY_MONITORING })
  handleClickInactivate(): void {
    const evolutionId = this.context.get('evolutionId');
    const encounterId = this.context.get('encounterId');
    const patientId = this.context.get('patientId');

    const modalProperties: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: FragmentNames.RESPIRATORY_MONITORING_INACTIVATE,
      id: FragmentNames.RESPIRATORY_MONITORING_INACTIVATE,
      onCancel: () => { },
      onSubmit: () => { },
      title: 'title.disable-record',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      encounterId,
      evolutionId,
      patientId,
    }

    ModalService.openDefault(modalProperties);
  }
}

export default RespiratoryMonitoringViewerController;
